import { CubeTimeDimensionGranularity } from '../../../common/enum/cube-time-dimension-granularity.enum';
import { CubeRequestConfig } from '../../../common/interface/cube-request-config.interface';
import { SharedOrgMetricsRequestDto } from '../common/shared-org-metrics-request.dto';

export interface GetAccountSentimentReportAverageSummaryRequestDto {
  params: {
    startDate: string;
    granularity: CubeTimeDimensionGranularity;
  } & SharedOrgMetricsRequestDto;
  config: CubeRequestConfig;
}
